// owner 只读独立页 /pack/manage/:id/files(TH1Qz) — 从 pack-manage 弹层抽出。
// 复用 PackFilesView(rows=PackDetail items 带封面;packId 支持下钻走 fetchItemsPreview)。
// owner 增删改仍走「添加文件」→ /folders/{id};此页只读,无 FAB / 订阅栏。
import { useNavigate, useParams } from 'react-router-dom'
import { Spinner } from '@dogdisk/shared'
import { AppLayout } from '../components/app-layout'
import { MobileScreen } from '../components/mobile-screen'
import { PackFilesView, type PackFileRow } from '../components/pack-files-view'
import { usePackDetail } from '../_lib/pack-api'

export function OwnerPackFilesPage() {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const detail = usePackDetail(id)

  if (detail.isLoading) {
    return (
      <AppLayout>
        <MobileScreen>
          <div className="flex flex-1 items-center justify-center"><Spinner className="text-gray-400" /></div>
        </MobileScreen>
      </AppLayout>
    )
  }
  if (detail.error || !detail.data) {
    return (
      <AppLayout>
        <MobileScreen>
          <div className="flex flex-1 items-center justify-center text-[14px] text-[#FF6B6B]">资源包不存在</div>
        </MobileScreen>
      </AppLayout>
    )
  }

  const rows: PackFileRow[] = detail.data.items.map((it) => ({
    key: it.file_info_id,
    itemId: it.file_info_id,
    name: it.name,
    type: it.type,
    size: it.size_original,
    mimeType: it.mime_type,
    coverThumbUrl: it.cover_thumb_url ?? null,
  }))

  return (
    <AppLayout>
      <MobileScreen>
        <PackFilesView onBack={() => navigate(`/pack/manage/${id}`)} packId={id} rows={rows} />
      </MobileScreen>
    </AppLayout>
  )
}

export default OwnerPackFilesPage
